<template>
    <v-main>
        <Hero/>
        <AboutComp/>
        <ProgramsComp/>
        <FacebookFrame/>
        <GalleryComp/>
    </v-main>
</template>
<script>
const Hero = ()=> import('../components/Hero.vue')
const AboutComp = ()=> import('../components/AboutComp.vue')
const ProgramsComp = ()=> import('../components/ProgramsComp.vue')
const GalleryComp = ()=> import('../components/GalleryComp.vue')
const FacebookFrame = ()=> import('../components/FacebookFrame.vue')
export default {
    name:'Home',
    components:{
        Hero,
        AboutComp,
        ProgramsComp,
        GalleryComp,
        FacebookFrame
    },
     metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Maryud103FM مريود | A private Sudanese radio station operating from Khartoum, Sudan',
      meta: [{
       vmid: 'description',
       name: 'description',
       content: 'A private Sudanese radio station operating from Khartoum, Sudan محطة اذاعة سودانية تبث من الخرطوم السودان',
     }]
   }
}
</script>
<style lang="scss">
    
</style>